import { render, staticRenderFns } from "./UjianBreak.vue?vue&type=template&id=9deb3b90"
import script from "./UjianBreak.vue?vue&type=script&lang=js"
export * from "./UjianBreak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports